import React, { Component } from "react";
import { Row, Card, CardTitle, Label, FormGroup, Button, CustomInput } from "reactstrap";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { CalculateColors } from '../../helpers/ThemeColors'
import { NotificationManager } from "../../components/common/react-notifications";
import { Formik, Form, Field } from "formik";
import cookie from 'react-cookies'; 
import { loginUser, getCompany } from "../../redux/actions";
import { Colxx } from "../../components/common/CustomBootstrap";
import IntlMessages from "../../helpers/IntlMessages";
import { dev } from "../../constants/defaultValues";
import jsLogger from "js-logger";
import { LogRequest } from "../../helpers/Interface";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      email: "",
      password: "",
      companyCode: false,
      humanView:false,
      showHuman:false
    };
    /*
     email: "kawonr@aol.com",
      password: "Diwoc9E",
       email: "Tom Ronan",
      password: "6gbdXBKW",
      email: "kawonr@aol.com",
      password: "Diwoc9E",
      */
  }

  static getDerivedStateFromProps(props, state) {
    var ret = {};
      if (props.companyCode && !props.company){
        props.getCompany({uri:'getCompanyCustomizations',obj:{companyId:props.companyCode}});
      }else{
          var str = document.URL;
          if (str.indexOf("dashboard") > -1){
            //companyCode is default;
          }else{
            if (!props.company){
            props.getCompany({uri:'getCompanyCustomizations',obj:{companyId:'maids.iluminere.fm'}});           
            }
            
          }
          if (props.company){
            CalculateColors(props.company);
          }
      }
      return ret;
  }

  componentDidMount(){
    jsLogger.setLevel(jsLogger.INFO);
    var consoleHandler = jsLogger.createDefaultHandler();
    jsLogger.setHandler(async function (messages, context) {
      var _message = messages[0];
      var _unique = messages[1];
      var _subTopic = messages[3];
          delete messages[3];
          delete messages[0];
          delete messages[1];
      Array.prototype.unshift.call(messages, _unique);
      Array.prototype.unshift.call(messages, _subTopic);
      Array.prototype.unshift.call(messages, document.URL.toString());
      Array.prototype.unshift.call(messages, _unique);
      Array.prototype.unshift.call(messages, _message);
      Array.prototype.unshift.call(messages, new Date().getTime());
      Array.prototype.unshift.call(messages, "SimpliAd API");
      
      
       consoleHandler(messages, context);
      await LogRequest({obj:{"messages":messages,"level":context}});
    });
    
    var str = document.URL;
    if (str.indexOf("chuid") > -1){
      if (!this.props.activeState){}else{
        var parents = str.split("acc=");
        var parts = parents.pop().split("&chuid=");
        var values = {uri:"login",obj:{username:parts[0],password:parts[1],account:"analytics"}};
        
        jsLogger.info("Administrative Login",parts[0],"Admin Login");
        this.props.loginUser(values, this.props.history);
    }
    }
  }

  checkEmail = (e) => {
    var chk = ["maids","sterling","son89","cleanbros"];
var redirect = false;
    if (e && e.target.value){
      if (e.target.value.toLowerCase().indexOf("zblack") > -1){}else{
      var str = e.target.value.toLowerCase();
    redirect = chk.map((v) => {
          if (str.indexOf(v) > -1){
            return true;
          }else{
            return false;
          }
    }).filter(a=>a).length;
    }
  }
    if (redirect){
      window.location.assign("https://maids.simpliad.com/user/login");
    }
  }


  onUserLogin = (values) => {
    var _v = values;
    if (this.state.humanView){
    this.setState({submit:1},function(){
    if (!this.props.loading) {
      if (_v.email !== "" && _v.password !== "") {
        var values = {uri:"login",obj:{username:_v.email,password:_v.password,account:"analytics"}};
        jsLogger.info("Login Form Submission",_v.email,"User Login");
        this.props.loginUser(values, this.props.history);
      }
    }
  })}else{
    this.setState({showHuman:true},function(){

    })
  }
  }

  handleHumanView = (e) => {
    this.setState({humanView:!this.state.humanView});
  }

  validateEmail = (value) => {
    let error;
    if (!value) {
      error = "Please enter your email address";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
      error = "Invalid email address";
    }
    return error;
  }

  validatePassword = (value) => {
    let error;
    if (!value) {
      error = "Please enter your password";
    } else if (value.length < 4) {
      error = "Value must be longer than 3 characters";
    }
    return error;
  }

  componentDidUpdate() {
    if (this.props.error) {
      NotificationManager.warning(
        this.props.error,
        "Login Error",
        3000,
        null,
        null,
        ''
      );
    }
  }

  render() {
    const { password, email } = this.state;
    const initialValues = {email,password};
    var ident = ("?" + window.location.href).split("?").pop();
    ident = (ident.length > 3) ? "" : ident;
    var logo = (this.props.company && this.props.company.logo)?dev.assetPath+"/images/clients/logos/light-"+this.props.company.logo:"";
    logo = (logo === dev.assetPath+"/images/clients/logos/light-5.png")?dev.assetPath+"/images/clients/logos/light-white.png":logo;
    logo = logo+"?"+ident;
    const cname = (this.props.company && this.props.company.name)?this.props.company.name:"";
    return (
      <Row className="h-100">
        <Colxx xxs="12">
          <Row className="Align-parent">
            <div className="col- Aligner" >
            <div className="Aligner-item Aligner1 loginLogoText">
              Simpli<span className="logoAd">Ad.</span>
              </div>
           </div>
           <div className="col- Aligner Aligner2" >
           <div className="Aligner-item">
            <span className="simply-logo-border" />
            </div>
           </div>
            <div className="col- Aligner Aligner3" >
           <div className="Aligner-item loginLogo2" style={{backgroundImage: `url(${logo})`,backgroundSize:`contain`,backgroundRepeat:`no-repeat`,width:`93%`}} >
              
              <span className="logo-single2" />
              </div>
            </div>
          </Row>
         

          <Row>
            <Colxx xss="12" className="para-text">
              <div className="para indt">
             <div>
                   Welcome, {cname}
                   </div>
                   <div>
             
                Please log on below to access your dashboard.
                </div>
              </div>
                
            </Colxx>
          </Row>


          <Row>
            <Colxx xss="12">
            <Formik
                initialValues={initialValues}
                onSubmit={this.onUserLogin}>
                {({ values, errors, touched, handleBlur }) => (
                  <Form className="av-tooltip tooltip-label-bottom">
                    <FormGroup className="form-group has-float-label">
                      <Label className="lbl-email">
                        
                      </Label>
                      <Field
                        className="form-control email"
                        name="email"
                        onBlur={e => {
                          // call the built-in handleBur
                          handleBlur(e)
                          // and do something about e
                          this.checkEmail(e);
                        }
                      
                        }
                        
                      />
                      {errors.email && touched.email && (
                        <div className="invalid-feedback d-block error-email">
                          {errors.email}
                        </div>
                      )}
                    </FormGroup>
                    <FormGroup className="form-group has-float-label">
                      <Label className="lbl-password">
                       
                      </Label>
                      <Field
                        className="form-control password"
                        type="password"
                        name="password"
                      />
                      {errors.password && touched.password && (
                        <div className="invalid-feedback d-block error-password">
                          {errors.password}
                        </div>
                      )}
                    </FormGroup>
                    <div className={(this.state.showHuman) ? "block" : "none"}>
                <div className="clickIfHuman">Check this box to verify you are human.</div>
              <CustomInput
              className="itemCheck mb-0"
              type="checkbox"
              id={`check_10`}
              checked={this.state.humanView}
              onChange={e => this.handleHumanView(e)}
              label=""
            />
            </div>
                    <div className="login-submit">
                    <Button
                        color="primary"
                        className={`btn-shadow button-lg indt btn-multiple-state ${this.props.loading ? "show-spinner" : ""}`}
                        size="lg"
                      >
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">SUBMIT</span>
                      </Button>
                      </div>
                      <div className="no-disp d-none login-google">
                      <Button
                        color="secondary"
                        className={`btn-shadow button-lg indt btn-multiple-state ${this.props.loading ? "show-spinner" : ""}`}
                        size="lg"
                      >
                        
                        <span className="spinner d-inline-block">
                          <span className="bounce1" />
                          <span className="bounce2" />
                          <span className="bounce3" />
                        </span>
                        <span className="label">SIGN IN WITH GOOGLE</span>
                      </Button>
                      </div>
                    
                      <div className="login-register indt">
                        Need an account? 
                      <NavLink to={`/user/register`}>
                        &nbsp;Get Started
                      </NavLink>
                    </div>
                    <div className="login-forgot indt">
                        Forgot your login information? 
                      <NavLink to={`/user/forgot-password`}>
                      &nbsp;Reset Password
                      </NavLink>
                    </div>


                  </Form>
                )}
              </Formik>
           
            </Colxx>
          </Row>

        </Colxx>
      </Row>
    );
  }
}
const mapStateToProps = ({ authUser }) => {
  const { user, loading, error, company } = authUser;
  
  return {  user, company, loading, error };
};

export default connect(
  mapStateToProps,
  {
    loginUser,
    getCompany
  }
)(Login);
